import { camelizeKeys } from 'humps'

import type { API$Resort, Resort } from '~/types'

export default function resortDeserializer(data: API$Resort): Resort {
  return camelizeKeys(data)
}
